import Vue from 'vue'
import Router from 'vue-router'
import VisiteCantina from '@/components/VisiteCantina'
import Homepage from '@/components/Homepage'
import SchedaVini from '@/components/SchedaVini'
import Shop from '@/components/Shop'
// import Events from '@/components/Events'
// import Attivita from '@/components/Attivita'
import Ospitalita from '@/components/Ospitalita'
import Vini from '@/components/Vini'
import EventiRegistrazione from '@/components/EventiRegistrazione'
import Corsi from '@/components/Corsi'
import AttivitaRegistrazione from '@/components/AttivitaRegistrazione'
import AttivitaAperto from '@/components/AttivitaAperto'
import Carrello from '@/components/Carrello'
import CompletaOrdine from '@/components/CompletaOrdine'
import VisiteRegistrazione from '@/components/VisiteRegistrazione'
import Admin from '@/components/Admin'
import Login from '@/components/Login'
import SmartBox from '@/components/SmartBox'
import Territorio from '@/components/Territorio'
import Community from '@/components/Community'
import PrivacyCookiePolicy from '../components/PrivacyCookiePolicy.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage
    },
    {
      path: '/visite-in-cantina',
      name: 'visitecantina',
      component: VisiteCantina
    },
    {
      path: '/schedeprodotto',
      name: 'shop',
      component: Shop
    },
    {
      path: '/schedavini/:id',
      name: 'schedavini',
      component: SchedaVini
    },
    {
      path: '/smartbox/:id',
      name: 'smartbox',
      component: SmartBox
    },
    // {
    //   path: '/attivita',
    //   name: 'attivita',
    //   component: Attivita
    // },
    // {
    //   path: '/events',
    //   name: 'events',
    //   component: Events
    // },
    {
      path: '/ospitalita',
      name: 'ospitalita',
      component: Ospitalita
    },
    {
      path: '/eventiregistrazione/:id',
      name: 'eventiregistrazione',
      component: EventiRegistrazione
    },
    {
      path: '/vini',
      name: 'vini',
      component: Vini
    },
    {
      path: '/cose-da-fare-pavia-e-oltrepo-pavese',
      name: 'territorio',
      component: Territorio
    },
    {
      path: '/attivita/:catAttivita',
      name: 'corsi',
      component: Corsi
    },
    {
      path: '/attivitaregistrazione/:id',
      name: 'attivitaregistrazione',
      component: AttivitaRegistrazione
    },
    {
      path: '/attivita/:catAttivita',
      name: 'attivitaaperto',
      component: AttivitaAperto
    },
    {
      path: '/visiteregistrazione/:id',
      name: 'visiteregistrazione',
      component: VisiteRegistrazione
    },
    {
      path: '/carrello',
      name: 'carrello',
      component: Carrello
    },
    {
      path: '/completaordine',
      name: 'completaordine',
      component: CompletaOrdine
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/community',
      name: 'community',
      component: Community
    },
    {
      path: '/privacyCookiePolicy',
      name: 'privacyCookiePolicy',
      component: PrivacyCookiePolicy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js